export enum IntegrationProvider {
  ONYX = 'flespi',
  FORMULA = 'formula',
  FLEETHAND = 'fleethand',
  FRAME_LOGIC = 'frame-logic',
  GBOX = 'gbox',
  TRANSICS = 'transics',
  TRIMBLE = 'trimble',
}
